export const CONTENT_ITEM_TYPES = {
  ImageSliderContentItem: 'Карусель',
  ImageContentItem: 'Изображение',
  VideoContentItem: 'Видео',
  AudioContentItem: 'Аудио',
  TextContentItem: 'Редактор',
};

export const CONTENT_ITEM_KEYS = {
  ImageSliderContentItem: 'images',
  ImageContentItem: 'imgPath',
  VideoContentItem: 'videoPath',
  AudioContentItem: 'audioPath',
  TextContentItem: 'content',
};
